module.exports = __webpack_public_path__ + "static/media/HCMM385.dcf2ba56.jpg";